<template>
  <div class="consent-form">
    <div class="content">
      <h1>知情同意书</h1>
      <p>尊敬的参与者：</p>
      <p>感谢您参加我们的成果体验。在您同意参加体验之前，请仔细阅读以下内容。</p>

      成果体验的输入主要由一些个人基本信息和望、闻、问、切四诊信息构成。
      这些信息将由我们研究课题中成熟的算法及模型进行处理和维护。
      在你决定参加这项体验之前，请仔细阅读以下内容。如果你有任何疑问，欢迎随时向我们提问。

      <p><strong>体验目的：</strong><br>们的体验旨在探讨智能四诊在健康和疾病诊断中的应用。通过收集你的四诊信息，我们将分析不同特征与健康状态之间的关联。</p>
      <p><strong>体验过程：</strong><br>你除了被要求填写一些个人基本信息和问诊信息外，还将被要求坐在适当的位置和安静的环境拍摄你的舌面图像和采集你的闻诊声音。这个过程通常很快，不会对你的身体造成伤害。</p>
      <p><strong>风险和不适：</strong><br>舌面诊采集图像和闻诊声音采集是无创的，不会对你的身体造成伤害。有可能会感到一些不适，例如张口或保持舌头在特定位置。</p>
      <p><strong>益处：</strong><br>你的参与将有助于推动医学研究，改善健康诊疗及预后管理。你将有机会了解自己的智能医学诊断信息。</p>
      <p><strong>隐私保护：</strong><br>我们将严格保护你的隐私，只有研究团队才能访问你的数据。你的个人信息将被匿名化处理。你的参与是完全自愿的。如果你决定退出研究，你可以随时停止参与，而不会受到任何不良后果。
      </p>
      <p><strong>自愿参与：</strong><br>你的参与是完全自愿的。如果你决定退出研究，你可以随时停止参与，而不会受到任何不良后果。</p>
      <p>请确保你已经理解了上述内容。如果你有其他问题或需要更多信息，请随时告知。感谢你的参与!</p>
      <p>通过点击下方的"我同意"按钮，表示你已经理解并同意参加这项体验。</p>

      <div v-if="error" class="error-message">
        {{ error }}
      </div>

      <div class="buttons">
        <button class="agree-btn" @click="handleAgree" :disabled="isLoading">
          <span v-if="!isLoading">我同意</span>
          <span v-else>提交中...</span>
        </button>
        <button class="disagree-btn" @click="handleDisagree" :disabled="isLoading">
          我不同意
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aggreement',
  data() {
    return {
      isLoading: false,
      error: null
    };
  },
  methods: {
    async handleAgree() {
      try {
        this.isLoading = true;
        this.error = null;


        this.$emit('submit-consent', true);
      } catch (err) {
        this.error = '提交同意失败，请重试';
        console.error('同意出错:', err);
        let message = '提交失败，请重试';
        if (err.name === 'AbortError') {
          message = '请求超时，请检查网络';
        } else if (err.message.includes('网络')) {
          message = '网络连接异常';
        }

        await Swal.fire({
          title: '出错啦',
          text: message,
          icon: 'error',
          confirmButtonText: '知道了'
        });
      } finally {
        this.isLoading = false;
      }
    },

    async handleDisagree() {
      try {
        this.isLoading = true;
        this.error = null;


        this.$emit('submit-consent', false);
        alert('您需要同意才能继续使用服务');
      } catch (err) {
        this.error = '提交不同意失败';
        console.error('不同意出错:', err);
        let message = '提交失败，请重试';
        if (err.name === 'AbortError') {
          message = '请求超时，请检查网络';
        } else if (err.message.includes('网络')) {
          message = '网络连接异常';
        }

        await Swal.fire({
          title: '出错啦',
          text: message,
          icon: 'error',
          confirmButtonText: '知道了'
        });
      } finally {
        this.isLoading = false;
      }
    },

  }
}
</script>

<style scoped>
.consent-form {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.content h1 {
  text-align: center;
}

.buttons {
  display: flex;
  gap: 30px;
  justify-content: center;
  margin-top: 20px;
}

button {
  margin: 0;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  transition: all 0.3s ease;
}

/* 我同意按钮 - 绿色 */
.agree-btn {
  background-color: #4CAF50;
  color: white;
}

.agree-btn:hover:not(:disabled) {
  background-color: #45a049;
}

/* 我不同意按钮 - 红色 */
.disagree-btn {
  background-color: #f44336;
  color: white;
}

.disagree-btn:hover:not(:disabled) {
  background-color: #d32f2f;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  color: red;
  text-align: center;
  margin: 10px 0;
}
</style>
